"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useTranslations } from "next-intl";

export function PriceLink() {
  const t = useTranslations("header.nav");
  const pathname = usePathname();
  const locale = pathname?.split("/")[1] || "zh";

  return (
    <Link
      href={`/${locale}/pim/billing`}
      className="text-foreground/60 transition-colors hover:text-foreground"
    >
      {t("pricing")}
    </Link>
  );
}

export default PriceLink;
